import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom"
import { getPropertyList } from "../../Redux/Slices/BON-Frontend/propertyListSlice";
import { useEffect, useState } from "react";

const PropertyImage = ({ src, alt }) => {
  const [imageFailed, setImageFailed] = useState(false);
  const hasImage = Boolean(src?.trim()) && !imageFailed;

  if (!hasImage) {
    return (
      <div className="zzx_prop-image-placeholder" role="img" aria-label={`${alt || "Property"} image not available`}>
        <span className="material-symbols-outlined" aria-hidden="true">collections</span>
      </div>
    );
  }

  return <img src={src} alt={alt} onError={() => setImageFailed(true)} />;
};

export const Room = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { properties, loading } = useSelector((state) => state.propertyList);

  useEffect(() => {
    dispatch(getPropertyList());
  }, [dispatch]);
  return (

    <>
      {/* ===== FEATURED HOTELS ===== */}
      <section>
        <div className="container">
          <div className="d-flex align-items-center justify-content-between mb-2 flex-wrap gap-2">
            <div>
              <h2 className="zzx_section-title mb-0">Top Rated Stays</h2>
              <p className="zzx_section-sub mb-0">
                Handpicked properties loved by travellers
              </p>
            </div>
            {/* <a
              href="#"
              style={{
                color: "var(--primary)",
                fontWeight: 800,
                fontSize: "0.92rem",
                textDecoration: "none"
              }}
            >
              See all <i className="bi bi-arrow-right" />
            </a> */}
          </div>
          {/* Filter Pills */}
          <div className="d-flex gap-2 flex-wrap my-3">
            <button className="zzx_filter-pill">
              <i className="bi bi-building me-1" />
              All Hotels
            </button>
          </div>
          <div className="row g-4">
            {loading ? (
              <p>Loading...</p>
            ) : (
              properties?.map((hotel) => (
                <div className="col-sm-6 col-lg-4" key={hotel.PropertyID}>
                  <div
                    className="zzx_prop-card"
                    role="link"
                    tabIndex={0}
                    style={{ cursor: "pointer" }}
                    onClick={(event) => {
                      if (event.target.closest("a, button")) return;
                      navigate(`/Hotels/Home?pid=${hotel.PID}`);
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        navigate(`/Hotels/Home?pid=${hotel.PID}`);
                      }
                    }}
                    aria-label={`View ${hotel.DisplayName || "hotel"}`}
                  >
                    <div className="zzx_prop-card-img">
                      <PropertyImage
                        src={hotel.PropertySearchBanner}
                        alt={hotel.DisplayName}
                      />
                      <span className="zzx_prop-badge zzx_genius">Genius</span>
                      <button className="zzx_prop-wishlist">
                        <i className="bi bi-heart-fill" />
                      </button>
                    </div>
                    <div className="zzx_prop-card-body">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="zzx_prop-name">{hotel.DisplayName}</div>
                        <NavLink to={`/Hotels/Home?pid=${hotel.PID}`} className="zzx_prop-rating" > Book </NavLink>
                      </div>
                      <div className="zzx_prop-location">
                        <i className="bi bi-geo-alt-fill" /> {hotel.Address || "Address Not Available"}
                      </div>
                      <div className="zzx_prop-stars">★★★★★</div>
                      <div className="d-flex gap-2 flex-wrap mb-2">

                        <span
                          className="badge"
                          style={{
                            background: "#eef2ff",
                            color: "var(--primary)",
                            fontSize: "0.72rem",
                            fontWeight: 700,
                          }}
                        >
                          kjbf
                        </span>
                      </div>
                      <div className="zzx_prop-footer">
                        <div className="d-flex align-items-center">
                          <span className="zzx_prop-rating">9.2</span>
                          <span className="zzx_prop-rating-label">
                            Superb
                            <br />
                            <span style={{ fontSize: "0.7rem", color: "#aaa" }}>
                              4,821 reviews
                            </span>
                          </span>
                        </div>
                        <div className="zzx_prop-price">
                          <div className="zzx_price-from">Starting from</div>
                          {/* <div className="zzx_price-old">₹18,500</div> */}
                          <div className="zzx_price-amount">₹14,200</div>
                          <div className="zzx_price-night">per night</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </section>
    </>
  )
}
